define('views/modules/goal/story/goal-story-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/list/list',
    'views/modules/goal/story/goal-story-list-item',
    // templates
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VList,
    VGoalStoryListItem
    // templates
) {

    var VGoalStoryList = VList.extend({
        item: VGoalStoryListItem,

        getItemOptions: function(options) {
            return _.extend(options, _.pick(this.options, ['goal']));
        },

    });

    return VGoalStoryList;

});

